interface Setting {
  [column: string]: number;
}

export function getDefaultWidths(key: string): Setting {
  return JSON.parse(localStorage.getItem(key) || "{}");
}

export function saveColumnWidth(
  key: string,
  column: string,
  value: number
): void {
  const settings = getDefaultWidths(key);

  localStorage.setItem(
    key,
    JSON.stringify({
      ...settings,
      [column]: value,
    })
  );
}
